import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { ICPLCalendarEventsClient, IntSelectModel } from "./api/cplapi/CPLAPI";
import { CPLCalendarEvent, NewCPLCalendarEvent } from "./classes/CPLCalendarEvent";

export interface ICalendarEventService {
  getAllEventsForUser(): Promise<CPLCalendarEvent[]>;
  getCalendarEventTypeSelectModels(): Promise<IntSelectModel[]>;
  createCalendarEvent(calendarEvent: NewCPLCalendarEvent): Promise<number>;
  createCalendarEventUserMapping(calendarEventID: number, userID: string): Promise<void>;
  createCalendarEventUserGroupMapping(calendarEventID: number, userGroupID: number): Promise<void>;
  deleteCalendarEvent(calendarEventID: number): Promise<void>;
  deleteCalendarEventUserAndUserGroupMapping(mappingID: number): Promise<void>;
  updateCalendarEvent(calendarEvent: CPLCalendarEvent): Promise<void>;
}

@injectable()
export class CalendarEventService implements ICalendarEventService {
  @inject(SERVICE_TYPES.CPLCalendarEventsClient) cplCalendarEventsClient!: ICPLCalendarEventsClient;

  async updateCalendarEvent(calendarEvent: CPLCalendarEvent): Promise<void> {
    return this.cplCalendarEventsClient.updateCalendarEvent(calendarEvent);
  }

  async getAllEventsForUser(): Promise<CPLCalendarEvent[]> {
    return this.cplCalendarEventsClient.getCalendarEventsForUser();
  }

  async getCalendarEventTypeSelectModels(): Promise<IntSelectModel[]> {
    return this.cplCalendarEventsClient.getCalendarEventTypeSelectModels();
  }

  async deleteCalendarEvent(calendarEventID: number): Promise<void> {
    return this.cplCalendarEventsClient.deleteCalendarEvent(calendarEventID);
  }

  async deleteCalendarEventUserAndUserGroupMapping(mappingID: number): Promise<void> {
    return this.cplCalendarEventsClient.deleteCalendarEventUserAndUserGroupMapping(mappingID);
  }

  async createCalendarEvent(calendarEvent: NewCPLCalendarEvent): Promise<number> {
    return this.cplCalendarEventsClient.createCalendarEvent(calendarEvent);
  }

  async createCalendarEventUserMapping(calendarEventID: number, userID: string): Promise<void> {
    return this.cplCalendarEventsClient.createCalendarEventUserMapping(calendarEventID, userID);
  }

  async createCalendarEventUserGroupMapping(calendarEventID: number, userGroupID: number): Promise<void> {
    return this.cplCalendarEventsClient.createCalendarEventUserGroupMapping(calendarEventID, userGroupID);
  }
}
